{
  "id": "rheia",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Reia",
    "en": "Rheia"
  },
  "icon": "gods/rheia",
  "portrait": "gods/rheia-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "behemoth": 1
  },
  "unlocks": ["behemoth", "daktyloi", "horns-of-consecration", "orichalcum-mail", "rheias-gift"],
  "powers": ["traitor"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml HeroicAgeRheia)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 behemoth at the Temple (Kronos: +1 from KronosExtra*, so 2). God power Traitor (cooldown 180 s). Horns of Consecration enables Fanatics in the Heroic Age."
  }
}
